/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import { ARE_YOU_SURE, LABEL_BTN_CANCEL, UNSUBSCRIBE_EMAIL_SUCCESS, UNKNOWN_ERR, BULK_UNSUBSCRIBE_LEVELS, UNSUBSCRIBE_EMAIL_FAILURE } from 'src/constants/constant';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import type { UnsubscribeListType } from '../types/types';
import { getAllResubscribeEmail, removeEmailsFromUnsubscribeList } from 'src/services/unsubscribeService';
import { TextareaAutosize } from '@mui/material';
import moment from 'moment';
import { checkEventPermission } from "../../common/utility/utility";


const ITEM_HEIGHT = 48;

interface ApiResponse {
  status: number;
  data: {
    data: UnsubscribeListType[];
    result: number;
  };
}

const ReSubscribeList: React.FC = () => {

  const [unsubscribeData, setUnsubscribeData] = useState<UnsubscribeListType[]>([]);
  const [unsubscribeSearchData, setUnsubscribeSearchData] = useState<UnsubscribeListType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [unsubscribeEmailData, setUnsubscribeEmailData] = useState<any>(null);
  const [showDeleteUnsubscribeModal, setShowDeleteUnsubscribeModal] = useState<boolean>(false);
  const [submitmessage, setSubmitMessage] = useState('');
  const [validationError, setValidationError] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [anchorActionEl, setAnchorActionEl] = useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);


  useEffect(() => {
    getUnsubscribeListData();
  }, [user]);

  const getUnsubscribeListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ?? 0;
    getAllResubscribeEmail(ClientId)
      .then((res: ApiResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          setUnsubscribeData(res.data.data ? res.data.data : []);
          setUnsubscribeSearchData(res.data.data ? res.data.data : []);
        } else {
          setUnsubscribeData([]);
          setUnsubscribeSearchData([]);
        }
      })
      .catch((error) => {
      console.error('Failed to load unsubscribe list:', error);
    })
      .finally(() => setLoading(false));
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
      const value = e.target.value.trim();
      let unsubscribeDataArr = [...unsubscribeData]
      if (value !== "") {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
        unsubscribeDataArr = unsubscribeDataArr && unsubscribeDataArr.filter((unsubscribe: UnsubscribeListType) => {
          return unsubscribe.email.toLowerCase().search(value.toLowerCase()) >= 0
        })
      }
      setUnsubscribeSearchData(unsubscribeDataArr)
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, email: string): void => {
    setAnchorActionEl({ ...anchorActionEl, [email]: event.currentTarget });
  };

  const handleDeleteUnsubscribeEmail = (row: UnsubscribeListType): void => {
    setUnsubscribeEmailData(row);   
    setShowDeleteUnsubscribeModal(true);
    setAnchorActionEl({ ...anchorActionEl, [row.emailAddress]: null });
  };


  const handleDeleteUnsubscribeClose = (): void => {
    setSubmitMessage('');
    setValidationError('');
    setWarningMessage('');
    setShowDeleteUnsubscribeModal(false);
  };

  const handleDeleteUnsubscribeConfirm = async (): Promise<void> => {
    if (!submitmessage.trim()) {
      setValidationError("Please provide a reason for deletion.");
      return;
    }

    setIsModalLoading(true);

    try {
      const payload = {
        emailAddress: unsubscribeEmailData.emailAddress,
        clientId: unsubscribeEmailData.clientId,
        campaignId: unsubscribeEmailData.campaignId,
        campaignType: unsubscribeEmailData.campaignType,
        unsubscribeTypeId: unsubscribeEmailData.unsubscribeTypeId,
        reason: submitmessage,
        userId: user?.id ?? 0
      };
      const res = await removeEmailsFromUnsubscribeList(payload);

      if (res?.data?.result === 1) {
        NotificationManager.success(UNSUBSCRIBE_EMAIL_SUCCESS, "", 5000);

        setShowDeleteUnsubscribeModal(false);
        getUnsubscribeListData();
      }
      else {
        setShowDeleteUnsubscribeModal(false);
        NotificationManager.error(UNSUBSCRIBE_EMAIL_FAILURE,"",5000);
    }

    } catch (error) {
      console.log("Delete Error", error);

      NotificationManager.error(UNKNOWN_ERR,"",5000);

    } finally {
      setIsModalLoading(false);
    }
  };


  const columns: TableColumn<UnsubscribeListType>[] = [
    {
      name: 'Email',
      selector: (row) => row.email,
      width: '15%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.email} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.email}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Client',
      selector: (row) => row.clientName,
      width: '15%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.clientName} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.clientName}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Campaign',
      selector: (row) => row.campaignName,
      width: '15%',
      wrap: true,
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.campaignName} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.campaignName}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Resubscribed On',
      selector: (row: any) => moment(row.resubscribedOn).format("MM/DD/YYYY"),
      width: '10%',
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={moment(row.resubscribedOn).format("MM/DD/YYYY")} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{moment(row.resubscribedOn).format("MM/DD/YYYY")}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Unsubscribed On',
      selector: (row: any) => moment(row.unsubscribedOn).format("MM/DD/YYYY"),
      width: '10%',
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={moment(row.unsubscribedOn).format("MM/DD/YYYY")} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{moment(row.unsubscribedOn).format("MM/DD/YYYY")}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Unsubscribe Type',
      selector: (row) => row.unsubscribeTypeId,
      width: '10%',
      sortable: true,
      cell: (row) => {
        const match = BULK_UNSUBSCRIBE_LEVELS.find(
          (item) => item.value === String(row.unsubscribeTypeId)
        );
        const label = match?.label ?? "";

        return (
          <div className="flex py-4" style={{ width: '100%' }}>
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
              <CustomTooltip title={label} placement="bottom" arrow={false}>
                <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">
                  {label}
                </p>
              </CustomTooltip>
            </div>
          </div>
        );
      }
    },
    {
      name: 'Campaign Type',
      selector: (row) => row.campaignType,
      width: '10%',
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.campaignType} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.campaignType}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    {
      name: 'Reason',
      selector: (row) => row.reason,
      width: '10%',
      sortable: true,
      cell: (row) => (
        <div className="flex py-4" style={{ width: '100%' }}>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted w-full">
            <CustomTooltip title={row.reason} placement="bottom" arrow={false}>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full">{row.reason}</p>
            </CustomTooltip>
          </div>
        </div>
      )
    },
    // {
    //   name: 'Actions',
    //   width: '10%',
    //   center: true,
    //   cell: (row) => (
    //     <div className="flex items-center">

    //       {checkEventPermission('UNSUBSCRIBELIST_DELETE') && (
    //         <>
    //           <IconButton onClick={(e) => handleActionClick(e, row.emailAddress)}>
    //             <HugeiconsIcon 
    //               icon={MoreVerticalSolidRounded} 
    //               size={24} 
    //               color="#3A3A3A" 
    //               strokeWidth={0.2} 
    //             />
    //           </IconButton>

    //           <Menu
    //             id={`menu-${row.emailAddress}`}
    //             className="table-action-menu"
    //             anchorEl={anchorActionEl[row.emailAddress]}
    //             open={Boolean(anchorActionEl[row.emailAddress])}
    //             onClose={() =>
    //               setAnchorActionEl({ ...anchorActionEl, [row.emailAddress]: null })
    //             }
    //            slotProps={{ paper: {
    //               style: {
    //                 maxHeight: ITEM_HEIGHT * 4.5,
    //                 width: "16ch",
    //               },
    //             }}}
    //           >
    //             <MenuItem onClick={() => handleDeleteUnsubscribeEmail(row)}>
    //               <span style={{ paddingLeft: "15px", color: "#F13139" }}>
    //                 Delete
    //               </span>
    //             </MenuItem>
    //           </Menu>
    //         </>
    //       )}

    //     </div>
    //   )
    // }

  ];

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Resubscribe List</h2>
      <div className="mt-[20px] mb-[20px]">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <input
              type="text"
              placeholder="Search by email"
              className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
              onChange={handleSearch}
            />
          </Grid>
        </Grid>
      </div>

      <div className='data-table-container mb-10 te-table-container'>
        <CustomDataTable
          columns={columns}
          data={unsubscribeSearchData}
          pagination
          progressPending={loading}
        />
      </div>

      <MUIModal title={"Delete Email"} openModal={showDeleteUnsubscribeModal} closeModal={handleDeleteUnsubscribeClose} width={'50%'}>

        <div className="px-[16px] pt-[10px] pb-[30px]">
            <p className="text-14 text-muted">{ARE_YOU_SURE} delete the email{" "}<span className="font-semibold">{unsubscribeEmailData?.emailAddress}</span> from unsubscribe list?</p>

            <TextareaAutosize
                minRows={3}
                placeholder="Enter your comment"
                value={submitmessage}
                onChange={(e) => {
                  setSubmitMessage(e.target.value);
                  setValidationError('');
                  setWarningMessage('');
                }}
                className="w-full border rounded-md p-2 mt-2"
                style={{
                  borderColor: validationError ? 'red' : '#ccc',
                  fontSize: '14px'
                }}
            />

            {validationError && (
                <div className="flex text-primary mt-2 text-md">
                  <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
                  {validationError}
                </div>
            )}

            {warningMessage && (
                <div className="flex text-primary mt-2 text-md">
                  <img src="/assets/images/attention.svg" alt="Warning" width={12} height={12} className="mr-1" />
                  {warningMessage}
                </div>
            )}
        </div>

        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
            <div className="w-full relative col-span-3">
                <button
                  type="button"
                  className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
                  onClick={handleDeleteUnsubscribeClose}
                >
                  {LABEL_BTN_CANCEL}
                </button>
            </div>

            <div className="w-full relative col-span-3">
                <button
                  type="button"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={handleDeleteUnsubscribeConfirm}
                  className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
                >
                  {!isModalLoading ? "Delete" : (<span className="loading loading-spinner loading-xs text-white"></span>)}
                </button>
            </div>
        </div>

      </MUIModal>

    </>
  );
};

export default ReSubscribeList;

